import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { PersistConfig } from 'redux-persist'
import { storage } from '../core'
import {
  Conversation,
  ConversationsState,
  SaveConversationPayload,
  StartConversationPayload,
} from './conversations.types'

const MAX_CONVERSATIONS = 30

const initialState: ConversationsState = {
  items: [],
  activeId: null,
}

export const CONVERSATIONS_STATE_NAME = 'conversations'

export const conversationsSlice = createSlice({
  name: CONVERSATIONS_STATE_NAME,
  initialState,
  reducers: {
    // A conversation is created the moment its first search runs, so it starts
    // empty and fills in as turns land.
    startConversation: (state, action: PayloadAction<StartConversationPayload>) => {
      const conversation: Conversation = { ...action.payload, messages: [] }
      state.items = [conversation, ...state.items].slice(0, MAX_CONVERSATIONS)
      state.activeId = conversation.id
    },
    saveConversation: (state, action: PayloadAction<SaveConversationPayload>) => {
      const conversation = state.items.find((item) => item.id === action.payload.id)
      if (conversation) conversation.messages = action.payload.messages
    },
    openConversation: (state, action: PayloadAction<string>) => {
      state.activeId = action.payload
    },
    // Leaving the active conversation — the composer returns to the hero.
    closeConversation: (state) => {
      state.activeId = null
    },
    removeConversation: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((item) => item.id !== action.payload)
      if (state.activeId === action.payload) state.activeId = null
    },
    clearConversations: (state) => {
      state.items = []
      state.activeId = null
    },
  },
})

export const conversationsSliceConfig: PersistConfig<ConversationsState> = {
  storage,
  key: CONVERSATIONS_STATE_NAME,
  whitelist: ['items', 'activeId'],
}

export const {
  startConversation,
  saveConversation,
  openConversation,
  closeConversation,
  removeConversation,
  clearConversations,
} = conversationsSlice.actions

export default conversationsSlice.reducer
